export enum ConfirmationResult {
  ACCEPT,
  CANCEL,
}

export enum RemoveUserFromGroupToastMessage {
  SUCCESS = 'remove-member-from-group-success-legacy',
  ERROR = 'remove-member-from-group-error-legacy',
}
